import { render, staticRenderFns } from "./medicalHome.vue?vue&type=template&id=3c614209&scoped=true&"
import script from "./medicalHome.vue?vue&type=script&lang=js&"
export * from "./medicalHome.vue?vue&type=script&lang=js&"
import style0 from "./medicalHome.vue?vue&type=style&index=0&id=3c614209&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c614209",
  null
  
)

export default component.exports